import React from "react";

export default function VanJudgementModal({ open, analysis, conflictMapText, onClose }) {
  if (!open) return null;

  const request = analysis?.analysis_request || analysis?.request || {};
  const result = analysis?.analysis_result || analysis?.result || analysis || {};
  const resultText = String(result?.result_text || "").trim();
  const traceId = String(result?.trace_id || "").trim();
  const status = String(result?.analysis_status || "").trim();
  const summaryObserved = String(result?.summary_observed || "").trim();
  const vanVerdict = String(result?.van_verdict || "").trim();
  const missingInformation = String(result?.missing_information || "").trim();
  const clarificationQuestions = Array.isArray(result?.clarification_questions)
    ? result.clarification_questions
    : [];

  return (
    <div className="vh-chatrooms-modal-backdrop" role="dialog" aria-modal="true">
      <div className="vh-chatrooms-modal">
        <div className="vh-chatrooms-modal-header">
          <div>
            <div className="vh-chatrooms-modal-eyebrow">Tribunal do Cacador</div>
            <h2>Veredito do Van Helsin</h2>
          </div>
          <button type="button" className="btn gothic-btn" onClick={onClose}>
            Fechar
          </button>
        </div>

        <div className="vh-chatrooms-judgement-meta">
          <span className="music-status-badge">Lente: {request?.lens || "heroi"}</span>
          {status ? <span className="music-status-badge">Status: {status}</span> : null}
          {traceId ? <span className="music-status-badge">trace_id: {traceId}</span> : null}
        </div>

        {summaryObserved ? (
          <section className="vh-chatrooms-modal-block">
            <div className="vh-chatrooms-section-label">Resumo observado</div>
            <div className="vh-chatrooms-result-text">{summaryObserved}</div>
          </section>
        ) : null}

        {vanVerdict ? (
          <section className="vh-chatrooms-modal-block">
            <div className="vh-chatrooms-section-label">Parecer do Van Helsin</div>
            <div className="vh-chatrooms-result-text">{vanVerdict}</div>
          </section>
        ) : null}

        {missingInformation ? (
          <section className="vh-chatrooms-modal-block">
            <div className="vh-chatrooms-section-label">O que ainda falta</div>
            <div className="vh-chatrooms-result-text">{missingInformation}</div>
          </section>
        ) : null}

        {clarificationQuestions.length ? (
          <section className="vh-chatrooms-modal-block">
            <div className="vh-chatrooms-section-label">Perguntas para refinar o julgamento</div>
            <ul className="vh-chatrooms-question-list">
              {clarificationQuestions.map((item, index) => (
                <li key={`clarify-${index}`}>{String(item || "")}</li>
              ))}
            </ul>
          </section>
        ) : null}

        {conflictMapText ? (
          <section className="vh-chatrooms-modal-block">
            <div className="vh-chatrooms-section-label">Mapa do conflito</div>
            <pre className="vh-chatrooms-conflict-map">{String(conflictMapText).trim()}</pre>
          </section>
        ) : null}

        <section className="vh-chatrooms-modal-block">
          <div className="vh-chatrooms-section-label">Parecer completo</div>
          <pre className="vh-chatrooms-result-text">{resultText || "Sem resultado."}</pre>
        </section>
      </div>
    </div>
  );
}
